import * as Sentry from "@sentry/vue"
import dayjs from "dayjs"

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig()
  const { COMMIT_SHA, COMMIT_TIMESTAMP, ENVIRONMENT_TIER } = config.public

  const dsn = config.public.SENTRY_DSN

  const date = COMMIT_TIMESTAMP ? dayjs(COMMIT_TIMESTAMP) : dayjs()
  const versionString = `${date.format("YY.M")}.${COMMIT_SHA}`

  const release = `SAM-Front@${versionString}`

  const ignoreErrors: Array<string> | undefined = process.env.ENVIRONMENT_TIER === "production" ? undefined : ["File not found"]

  Sentry.init({
    dsn,
    sendDefaultPii: false,
    release,
    environment: ENVIRONMENT_TIER,
    enabled: ENVIRONMENT_TIER !== "local",
    app: vueApp,
    ignoreErrors,
    integrations: [],
    tracesSampleRate: 0, // disable performance traces
    replaysSessionSampleRate: 0, // disable general session replay
    replaysOnErrorSampleRate: 0, // disable error session replay
    beforeSend(event) {
      // Remove user data from Sentry events to avoid sending sensitive information
      delete event.user

      // Remove request data
      if (event.request) {
        delete event.request.cookies
        delete event.request.headers
        delete event.request.data
        delete event.request.query_string
      }

      // Clean up extra context
      delete event.extra
      delete event.contexts?.trace

      return event
    },
    beforeBreadcrumb(breadcrumb) {
      const category = breadcrumb.category ?? ""

      // Ignore XHR and fetch breadcrumbs to avoid logging sensitive information
      if (category.includes("xhr")) return null
      if (category.includes("fetch")) return null

      // Ignore console breadcrumbs to avoid logging sensitive information
      // Like console.log, console.error, etc.
      if (category.includes("console")) return null

      return breadcrumb
    },
  })
})
